export default "__VITE_ASSET__BPiTIlh0__"